import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Slider from 'react-slick';

import './slick.scss';
import './tab-slider.scss';

const MAX_OFFSET = 96;
const TOP_SLIDE_INDENT = 0.25;

export class TabParallaxFixed extends PureComponent {
  render() {
    return (
      <div
        className="parallax"
        style={{ backgroundImage: `url("${this.props.background}")` }}
      />
    );
  }
}

export class TabParallaxSlides extends PureComponent {
  constructor(...props) {
    super(...props);

    this.slides = [];
  }

  componentDidMount() {
    this.setTranslate();

    const { activeIndex, slideIndex, parallax } = this.props;

    if ((activeIndex === slideIndex) && !!parallax.length) {
      window.addEventListener('mousemove', this.setLayersPosition, false);
    }
  }

  componentWillUnmount() {
    this.timer = null;

    if (this.props.activeIndex === this.props.slideIndex) {
      window.removeEventListener('mousemove', this.setLayersPosition, false);
    }
  }

  componentWillReceiveProps(nextProps) {
    if (typeof nextProps.forceIndex === 'number' &&
        this.props.forceIndex !== nextProps.forceIndex &&
        this.props.slideIndex === this.props.activeIndex) {
      window.removeEventListener('mousemove', this.setLayersPosition, false);
      this.setLayersPosition({});
    }

    if (typeof nextProps.forceIndex === 'number' &&
        nextProps.forceIndex !== this.props.forceIndex &&
        nextProps.slideIndex === nextProps.forceIndex &&
        !!this.props.parallax.length) {
      window.addEventListener('mousemove', this.setLayersPosition, false);
      this.setLayersPosition({});
    }
  }

  setTranslate = (screenX) => {
    const factor = (1 - 2 * screenX / window.innerWidth) * MAX_OFFSET;

    for (let i = 0; i < this.slides.length; i++) {
      let translate = 0;

      if (typeof screenX === 'number') {
        const slideIndent = (1 - TOP_SLIDE_INDENT) * i / (this.slides.length - 1);
        translate = (TOP_SLIDE_INDENT + slideIndent) * factor;
      }

      if (this.slides[this.slides.length - 1 - i]) {
        this.slides[this.slides.length - 1 - i].style.transform = `translateX(${Math.round(translate)}px)`;
      }
    }
  };

  setLayersPosition = ({ screenX }) => {
    if (this.timer) {
      return;
    }

    this.timer = setTimeout(() => {
      this.setTranslate(screenX);

      this.timer = null;
    }, 50);
  };

  render() {
    return (
      <div
        className="parallax"
        style={{ backgroundImage: `url("${this.props.background}")` }}
      >
        {this.props.parallax.map((item, index) =>
          <div
            key={item}
            ref={elem => { this.slides[index] = elem; }}
            style={{ backgroundImage: `url(${item})` }}
          />
        )}
      </div>
    );
  }
}

TabParallaxSlides.propTypes = {
  activeIndex: PropTypes.number.isRequired,
  forceIndex: PropTypes.number,
  slideIndex: PropTypes.number,
  pathname: PropTypes.string.isRequired,
  background: PropTypes.string.isRequired,
  parallax: PropTypes.arrayOf(PropTypes.string).isRequired
};

export class TabSlider extends PureComponent {
  constructor(...props) {
    super(...props);

    this.state = {
      activeIndex: this.props.activeIndex
    };
  }

  componentDidUpdate(prevProps, prevState) {
    const { forceIndex } = this.props;

    if (prevProps.forceIndex !== forceIndex && forceIndex !== null) {
      this.slider.slickGoTo(forceIndex);
    }
  }

  beforeChange = (oldIndex, newIndex) => {
    this.props.onSlide(oldIndex, newIndex);
  };

  afterChange = (activeIndex) => {
    this.setState({ activeIndex });
    this.props.onSlide(activeIndex, activeIndex);
  };

  render() {
    const SlideComponent = this.props.isMobile
      ? TabParallaxFixed
      : TabParallaxSlides;

    return (
      <Slider
        className="slick-parallax"
        ref={elem => { this.slider = elem; }}
        arrows={false}
        draggable={this.props.isMobile}
        infinite={false}
        dots={this.props.isMobile}
        initialSlide={this.state.activeIndex}
        speed={500}
        slidesToScroll={1}
        slidesToShow={1}
        beforeChange={this.beforeChange}
        afterChange={this.afterChange}
        touchThreshold={50}
      >
        {this.props.tabs.map((tab, index) =>
          <div key={tab.pathname}>
            <SlideComponent
              activeIndex={this.state.activeIndex}
              forceIndex={this.props.forceIndex}
              slideIndex={index}
              pathname={tab.pathname}
              background={tab.background}
              parallax={tab.parallax}
            />
          </div>
        )}
      </Slider>
    );
  }
}

TabSlider.propTypes = {
  activeIndex: PropTypes.number.isRequired,
  forceIndex: PropTypes.number,
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      pathname: PropTypes.string,
      button: PropTypes.string,
      title: PropTypes.string,
      description: PropTypes.string,
      background: PropTypes.string,
      parallax: PropTypes.arrayOf(PropTypes.string),
      links: PropTypes.arrayOf(PropTypes.object)
    })
  ).isRequired,
  isMobile: PropTypes.bool.isRequired,
  onSlide: PropTypes.func.isRequired
};

export default TabSlider;



// WEBPACK FOOTER //
// ./src/components/Main/TabSlider.js